<template>
  <article class="user_view">    
    <left-menu/>
    <modal-export @cancel="onCancelExport" @activate="onActivateExport" v-if="modalExportActive"/>
    <section class="user_view__header">
      <div class="user_view__header--info"> 
        <div>
          <h1>Guardas</h1>
          <h4>Listado de guardas registrados</h4>
          
        </div>
      </div>
      <div class="user_view__header--sec1">
        <!--div class="date_filter">
          <input v-model="dateFrom" placeholder="Desde" onfocus="(this.type='date')" onblur="(this.type='text')" type="text" class="date_filter__selector">
          <input v-model="dateTo" placeholder="Hasta" onfocus="(this.type='date')" onblur="(this.type='text')" type="text" class="date_filter__selector">
          <button :class="{'active': isComplete()}" class="secondary_button" >FILTRAR</button>
        </div-->
        <div style="width:auto">
          <button style="width:27%;cursor:progress"  class="secondary_button" :class="{'click':isUpdate, 'active': !isUpdate}"  @click="toUpdate" > <img style="width:40%" src="./../../assets/img/icons/icons8-refresh.svg"></button>
          <button class="secondary_button" :class="{'click':isReported, 'active':true}" @click="reports" >PENDIENTES</button>
        </div>
        
        <div>
          <button @click="exportSummary" class="primary_button">RESUMEN</button>
          <button v-if="getRol() == 'admin' || getRol() == 'coord'" class="primary_button" @click="$router.push({ name: 'CreateGuard' })" >CREAR</button>
        </div>        
      </div>
      <info-table :name="'guardas'" :columns="columns" :items.sync="guards" :actions="true"/>
      
    <div class="info_table__foot">
      <div/>
      <div class="paginator">
        {{shownItemsFrom}} - {{shownItemsTo}} 
        <div class="paginator__numbers">
          <div v-for="(page,i) in total_pages" @click="handlePageChange(i+1)" :key=i class="paginator__numbers--num" :class="{'active': currentPage==i+1}">
            {{i+1}}
          </div>
          <div class="paginator__numbers--num" @click="handlePageChange(currentPage+1)">
            >
          </div>
        </div>
      </div>
    </div>
    
    </section>
  </article>
</template>

<script>
import Table from './../shared/Table';
export default {
  data(){
    return{
      isReported:false,
      isUpdate:false,
      dateFrom:'',
      dateTo:'',
      columns:[
        {
          name: 'ID',
          sortable: true,
          clickable: true,
        },
        {
          name: 'Nombre',
          sortable: true,
        },
        {
          name: 'Cedula',
          sortable: true,
        },
        {
          name: 'Disp. actual',
          sortable: true,
        },
        {
          name: 'Estado actual',
          sortable: true,
        },
        {
          name: 'Acciones',
          lockable:true,
          enabled: true,
        }
      ],   
      guards:[],
      modalExportActive: false,
      meses:{
        "01":"ENERO",
        "02":"FEBRERO",
        "03":"MARZO",
        "04":"ABRIL",
        "05":"MAYO",
        "06":"JUNIO",
        "07":"JULIO",
        "08":"AGOSTO",
        "09":"SEPTIEMBRE",
        "10":"OCTUBRE",
        "11":"NOVIEMBRE",
        "12":"DICIEMBRE"
        },
      headersCSV:{
        start_date:"FECHA DE INICIO",
        start_hour:"HORA DE INICIO", 
        end_date:"FECHA DE SALIDA",
        end_hour:"HORA DE SALIDA",
        location_device: "UBICACION DEL DISPOSITIVO",   
        guard:"NOMBRE DEL GUARDA",
        guardDocument:"DOCUMENTO",
        number_device: "NUMERO DEL DISPOSITIVO",
        is_diurnal:"HORARIO",    
        reports: "NUMERO DE REPORTES EN TURNO",          
        id:"NUMERO DE TURNO", 

      },
      headersGuards:{
        name: "NOMBRE GUARDA",
        id:"DOCUMENTO",
        least4:"TURNOS MENORES A 4 HORAS",
        least8:"TURNOS DE 4 A 8 HORAS",
        greaterThan8:"TURNOS DE 8 A 11 HORAS",
        greaterThan12:"TURNOS DE 12 O MÁS HORAS",
        withoutEnd:"TURNOS SIN FINALIZAR",
        strangeTurn:"TURNOS PARA REVISAR",
        reportsTurn:"REPORTES MES GUARDA"
      },
      total_pages: 0,
      currentPage: 1,
      shownItemsFrom:0,
      shownItemsTo: 12,
      maxPage:12,
    }
  },
  components:{
      'info-table':Table, 
  },
  methods:{


    handlePageChange(value) {
      this.currentPage = value;
      this.toUpdate()
    },

      changeButton(){
       setTimeout(function(){
          
         this.isUpdate=false;
      },4000,"JavaScript");
          
        
      },
      isComplete(){
        if(this.dateFrom!='' && this.dateTo!=''){
          return true;
        }
      },
      toUpdate() {       
        this.isUpdate=true;    
        this.changeButton();
        const customActions={
          get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
        };
        var card=JSON.parse(localStorage.getItem("user")).id_card;     
        this.$resource('guards/dashboard' + '?page=' + this.currentPage,{},customActions).get({id_card: card})
        .then(function(data){
          // this.guards=data.body; 
          this.total_pages = data.body.total_pages
          this.guards=data.body.data; 
          console.log('los guardas la data ',data) 
          this.isUpdate=false;            
        });       
      },
      reports(){
        this.isReported=true;  
        setTimeout(() => { this.isReported=false; }, 200);
        this.$router.push({ name: 'Notice' })
      },
      exportSummary(){
        this.modalExportActive = true;
      },
      onActivateExport(value){
        this.modalExportActive=false;

        const customActions={
            get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
        };
        this.lastMonth=value.fecha.split("-")[1];

        this.$resource('company_devices',{},customActions).get({nit:value.Contrato.nit, date:value.fecha})
        .then(function(data){       
          console.log(data); 
          const turnsByClient=data.body.turns;
          const turnsByGuard=data.body.guards;
          this.exportCSVFile(this.headersCSV,this.headersGuards,turnsByClient,turnsByGuard,value.Contrato.name+"_"+value.fecha);
          //console.log(data.body[0].user);
        });
      },
      onCancelExport(value){
        this.modalExportActive=false;      
      },
      exportCSVFile(headers,headers_Guardias, list,list2,fileTitle) {  
        var listOne = this.processTurns(list);
        var listTwo = this.processGuards(list2);
      

        //Las une junto con los nombres de las columnas tod en un objeto JSON.
        var itemsbefore =  JSON.parse(JSON.stringify(listTwo.concat('\r\n').concat(headers).concat(listOne)));
        if (headers_Guardias) {
            itemsbefore.unshift(headers_Guardias);
            itemsbefore.unshift(["RESUMEN MENSUAL DE "+this.meses[this.lastMonth] + " "+(fileTitle.split('_')[0]).toUpperCase()+"\r\n"]);
        }

          
          var jsonObject = JSON.stringify(itemsbefore);
          
          // Convierte este objeto JSON a formato CSV
          var csv = this.convertToCSV(jsonObject);

          var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

          //Asigna al boton el atributo para que sea posible descargar el archivo.

          var blob = new Blob([csv], { type: 'text/csv;charset=UTF-8;' });
          if (navigator.msSaveBlob) { // IE 10+
              navigator.msSaveBlob(blob, exportedFilenmae);
          } else {
              var link = document.getElementById("anchor");
              if (link.download !== undefined) { // feature detection
                  // Browsers that support HTML5 download attribute
                  var url = URL.createObjectURL(blob);
                  link.setAttribute("href", url);
                  link.setAttribute("download", exportedFilenmae);
                  //link.style.visibility = 'hidden';
                  //document.body.appendChild(link);
                  link.click();
                  //document.body.removeChild(link);
              }
          }
    },
    processTurns(datos){
      var processedData=[];     
      for(var i=0; i<datos.length;i++){
        var serviceItem={
        start_date:datos[i].start_date,
        start_hour:datos[i].start_hour,
        end_date:datos[i].end_date,
        end_hour:datos[i].end_hour,  
        location_device: datos[i].device.location,
        guard:datos[i].guard.name + " "+ datos[i].guard.last_name,
        guardDocument:datos[i].guard.id_card,          
        number_device: datos[i].device.number,
        is_diurnal:datos[i].is_diurnal, 
        reports:datos[i].reports,
        id:datos[i].id, 
        } 
        processedData.push(serviceItem);
      }
      return processedData;
    },
    processGuards(datos){
      var processedData=[];   
      var keys=Object.keys(datos);
               
      for(var i=0; i<keys.length;i++){  
        var num=keys[i]  
        var serviceItem={
        name:datos[keys[i]].name,
        id:keys[i],
        least4:datos[keys[i]].men,
        least8:datos[keys[i]].min,
        greaterThan8:datos[keys[i]].mid,
        greaterThan12:datos[keys[i]].may,
        withoutEnd:datos[keys[i]].sf,
        strangeTurn:datos[keys[i]].err,
        reportsTurn:datos[keys[i]].report,      
        }
        processedData.push(serviceItem);
      }
      return processedData;
    },
    convertToCSV(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = 'sep=,\r\n';

        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line != '') line += ','
                if(array[i][index]===true ){
                  line += "Diurno";                              
                }else if(array[i][index]===false){
                  line += "Nocturno";    
                }else if(array[i][index]===null){
                  line += "No se ha terminado";  
                }else{
                  line += array[i][index];
                }
                
                
            }
            str += line + '\r\n';
        }        
        return str;
    },
      
  },
  created(){
    
    this.toUpdate();
  },
  mounted() {
    
  },
  
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Guards.vue